import React from 'react';

const comunidades = (props) => {
  return (
    <div>
      <label>Comunidad:</label>
      <select onChange={props.handleChange}>
        <option value="">Seleccione una comunidad</option>
        <option value="Euskadi">Euskadi</option>
        <option value="Aragon">Aragon</option>
        <option value="Canarias">Canarias</option>
      </select>
    </div>
  );
};

export default comunidades;
